export const iconFontAwesomeDevicesHardwareComputer = (
	<i className="fa-solid fa-computer"></i>
);
